// extracted by mini-css-extract-plugin
export default {"modalBody":"styles_modalBody__xTlhr","modalCloseIcon":"styles_modalCloseIcon__Cqc7I"};